import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { api } from "@/lib/api";

export default function ForgotPassword() {
    const [email, setEmail] = useState("");
    const [loading, setLoading] = useState(false);
    const [sent, setSent] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await api.post("/auth/forgot-password", { email });
            setSent(true);
        } catch {
            toast.error("Something went wrong. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen grid lg:grid-cols-2 bg-white">
            <div className="hidden lg:flex flex-col justify-between p-12 border-r border-border grid-bg">
                <div>
                    <img src="/scout-ai-logo.png" alt="Scout AI" className="h-12 w-auto" />
                </div>
                <div className="max-w-md">
                    <p className="font-heading text-3xl font-bold leading-tight">
                        Locked out? It happens.
                    </p>
                    <p className="text-muted-foreground mt-3">
                        We'll email you a secure link to set a new password and get back to growing.
                    </p>
                </div>
            </div>

            <div className="flex items-center justify-center p-8">
                <div className="w-full max-w-sm space-y-5">
                    <div>
                        <div className="overline text-muted-foreground">Reset password</div>
                        <h1 className="font-heading text-4xl font-black mt-2">Forgot password?</h1>
                    </div>

                    {sent ? (
                        <div className="space-y-4" data-testid="forgot-sent">
                            <div className="card-os p-5">
                                <p className="text-sm text-foreground">
                                    If an account exists for <span className="font-medium">{email}</span>, a reset link is on its way.
                                    Check your inbox (and spam) — the link expires in 30 minutes.
                                </p>
                            </div>
                            <Link to="/login" className="text-sm text-brand font-medium hover:underline" data-testid="back-to-login">
                                ← Back to sign in
                            </Link>
                        </div>
                    ) : (
                        <form onSubmit={submit} className="space-y-5">
                            <p className="text-sm text-muted-foreground">
                                Enter your account email and we'll send you a reset link.
                            </p>
                            <div>
                                <label className="overline text-muted-foreground">Email</label>
                                <input
                                    data-testid="forgot-email"
                                    type="email" required value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    className="input-os mt-1" placeholder="you@company.com"
                                />
                            </div>
                            <button
                                data-testid="forgot-submit"
                                type="submit" disabled={loading}
                                className="btn-primary w-full disabled:opacity-50"
                            >
                                {loading ? "Sending…" : "Send reset link"}
                            </button>
                            <div className="text-sm text-muted-foreground text-center">
                                Remembered it?{" "}
                                <Link data-testid="back-to-login" to="/login" className="text-brand font-medium hover:underline">
                                    Back to sign in
                                </Link>
                            </div>
                        </form>
                    )}
                </div>
            </div>
        </div>
    );
}
